export default {
  'beforeradio.after': 'After',
  'beforeradio.prior': 'Prior',
  'beforeradio.message.transfer':
    'When schedule falls on non-business day, complete transfer one business day',
  'beforeradio.message.payment':
    'When schedule falls on non-business day, complete payment one business day',
  'beforeradio.aria.payment.after': 'Complete payment one business day after',
  'beforeradio.aria.payment.prior': 'Complete payment one business day prior',
  'beforeradio.aria.transfer.after': 'Complete transfer one business day after',
  'beforeradio.aria.transfer.prior': 'Complete transfer one business day prior'
};
